'use client';
import { createStyles } from '@s7/styles';

function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
var useStyles = createStyles(function(theme, param, param1) {
    var color = param.color;
    _object_destructuring_empty(param1);
    var _theme_fn = theme.fn, themeColor = _theme_fn.themeColor, primaryShade = _theme_fn.primaryShade;
    var shade = primaryShade(themeColor(color, theme.palette.primary.mid));
    return {
        root: {
            display: "inline",
            backgroundColor: shade,
            color: "inherit",
            borderRadius: theme.fn.borderRadius("0.5r")
        }
    };
});

export { useStyles as default };
